module.exports = __webpack_public_path__ + "static/before1-47adee6043180cfe43e450cdb0587f57.jpg";